module.exports = __webpack_public_path__ + "img/電気回路_3_7_4.1c96810d.png";